import React from "react";
import IBaseDTO from "src/Interfaces/baseDTO";
import { IActionCancelRef } from "../../../Panel/components/modalCancel";
import { IActionCommentsRef } from "../../../Panel/components/modalComments";
import { IActionEfficiencyRef } from "../../../Panel/components/modalEfficiency";
import { IActionHistoryRef } from "../../../Panel/components/modalHistory";
import { IActionPostponementRef } from "../../../Panel/components/modalPostponement";
import { IRefModalSubaction } from "../../../Panel/components/modalsSubactions";
import { IActionShowPostponementRef, IListActions, IRefActionsPanelModalAddChangeDelete, IRefActionsProgressModal } from "../../../Panel/interface";



export interface ColumnKanban{
  kba002Id: number;
  kba002Cor: string;
  kba002Descricao: string;
  kba002Ordem: number;
}


export interface RowKanban extends IListActions{
  id: string;
  inb017Ordem: number;
}

export interface IRefKanbanModal{
  actionButtonAdd: (onCallbackAdd?: Function) => void;
  actionButtonChange: (kanbanId: number) => void;
  actionButtonDelete: (kanbanId: number, kanbanName: string) => void;
}

export enum IKanbanAssociations{
  ACTIONS = 1,
  PROJECTS = 2,
}

export interface IModalAddOrChangeKanban {
  onCallbackChange?: Function | undefined;
  onCallbackDelete?: Function | undefined;
}

export interface IKanban extends IBaseDTO{
  kba001Id: number;
  kba001Descricao: string;
  kba001Ativo: string;
  kba001Efa002Id: number;
  kba001Efa005Id: number;
  kba001Efa005Id2: number;
  kba001Tipo: IKanbanType;
  kbtba003?: {
    kba003Id: number;
    kba003Kba001Id: number;
    kba003Tipo: "C" | "I",
    kba003Efa004Id?: number;
    kba003Efa005Id?: number;
  }[];
  permission: number;
  associateType?: 1 | 2
}

export enum IKanbanType{
  ACTIONS = 1,
  PROJECT = 2,
}

export enum IKanbanModels{
  ACTIONS = 1,
  PROJECT = 2,
  PROJECT_AGILE = 3,
}


export interface IFilters{
  responsible: string | {
    value: string;
    label: string;
  };
  late: string;
  situation: {
    value: string;
    label: string;
  }[] | string | undefined;
  startDate: Date | null;
  endDate: Date | null;
}

export interface IFiltersKanban{
  active: string;
  filter: string;
  type: string;
}


export interface ICardStyled{
  selected: boolean;
  color: string;
}


export interface IColumnsKanban{
  activeId: string | null;
  disabled?: boolean;
  newItemsContainerName: string;
  containers: string[];
  items: Record<string, RowKanban[]>;
  columns: Record<string, ColumnKanban>;
	selectedKanban?: IKanban | undefined;
  findContainer: (idX: string) => string | undefined;
  onChangeColorColumn: (containerKey: string, newColor: string) => void;
  onChangeTitleColumn: (containerKey: string, newTitle: string) => void;
	handleAddColumn: () => void;
  onRemoveColumn: (containerID: string) => void;
	placeholderId: string;
	modalsRef: React.RefObject<IRefActionsPanelModalAddChangeDelete>;
	modalCommentsRef : React.RefObject<IActionCommentsRef>;
  modalsSubactionsRef: React.RefObject<IRefModalSubaction>;
  modalProgressRef: React.RefObject<IRefActionsProgressModal>;
  modalHistoryRef: React.RefObject<IActionHistoryRef>;
  modalPostponementRef: React.RefObject<IActionPostponementRef>;
  modalCancelRef: React.RefObject<IActionCancelRef>;
  modalEfficiencyRef: React.RefObject<IActionEfficiencyRef>;
  modalShowPostponementsRef: React.RefObject<IActionShowPostponementRef>
  onCallbackUpdateFunction: Function;
  typeKanban?: IKanbanModels
}

export interface IKanbanContent {
  columns: Record<string, ColumnKanban>;
	containers: string[];
	findContainer: (idX: string) => string | undefined;
	waitingForResponse: boolean;
	items: Record<string, RowKanban[]>;
	onRemoveColumn: (containerID: string) => Promise<void>;
	handleAddColumn: () => Promise<void>;
	activeId: string | null;
	selectedKanban: IKanban;
  typeKanban: IKanbanModels;
  setcolumns: React.Dispatch<React.SetStateAction<Record<string, ColumnKanban>>>
	modalCancelRef: React.RefObject<IActionCancelRef>;
	modalCommentsRef: React.RefObject<IActionCommentsRef>;
	modalEfficiencyRef: React.RefObject<IActionEfficiencyRef>;
	modalHistoryRef: React.RefObject<IActionHistoryRef>;
	modalPostponementRef: React.RefObject<IActionPostponementRef>;
	modalProgressRef: React.RefObject<IRefActionsProgressModal>;
	modalAddChangeDelete: React.RefObject<IRefActionsPanelModalAddChangeDelete>;
	modalsSubactionsRef: React.RefObject<IRefModalSubaction>;
  modalShowPostponementsRef: React.RefObject<IActionShowPostponementRef>;
	callbackUpdateAction: (id: string) => Promise<void>;
	ITEMS_WITH_NO_CONTAINER: string;
	PLACEHOLDER_ID: string;
  associations: IAssociations | undefined;
  errorAssociation: {
    module: "AC" | "PR";
    code: string;
  } | undefined;
  queryColumnsKanban: (kanban: IKanban, associationsX: IAssociations | undefined) => Promise<void>;
}

export interface IAssociations { 
  associationId?: number,
  associationId2?: number
}
